/**
 * Copyright 2018 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 **/

import { createStore, applyMiddleware, compose} from 'redux';
import baseReducer from './reducers/base-reducer';
import presentationsReducer from './reducers/presentations-reducer';
import selectionsReducer from './reducers/selections-reducer';
import { loggedUserReducer } from "openstack-uicore-foundation/lib/security/reducers";
import changeRequestsReducer from "./reducers/change-requests-reducer";
import scheduleReducer from "./reducers/schedule-reducer";
import clockReducer from "./reducers/clock-reducer";


import thunk from 'redux-thunk';
import { persistStore, persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/es/storage';

const config = {
    key: 'track-chairs',
    storage,
};

const reducers = persistCombineReducers(config, {
    loggedUserState: loggedUserReducer,
    baseState: baseReducer,
    presentationsState: presentationsReducer,
    selectionsState: selectionsReducer,
    changeRequestsState: changeRequestsReducer,
    scheduleState: scheduleReducer,
    clockState: clockReducer,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(reducers, composeEnhancers(applyMiddleware(thunk)));

const onRehydrateComplete = () => {
    // repopulate access token on global access variable
    window.sessionState = store.getState().loggedUserState.sessionState;
};

export const persistor = persistStore(store, null, onRehydrateComplete);
export default store;
